import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LocationProvider } from "@/context/LocationContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute, { DriverRoute } from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import LiveBoard from "@/pages/LiveBoard";
import OwnerDashboard from "@/pages/OwnerDashboard";
import MonthlyAccounts from "@/pages/MonthlyAccounts";
import Settings from "@/pages/Settings";
import Activity from "@/pages/Activity";
import History from "@/pages/History";
import Loyalty from "@/pages/Loyalty";
import CustomerProfile from "@/pages/CustomerProfile";
import LayoutEditor from "@/pages/LayoutEditor";
import Reports from "@/pages/Reports";
import DriverPortal from "@/pages/DriverPortal";
import RenewPage from "@/pages/RenewPage";
import Team from "@/pages/Team";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LocationProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/renew/:token" element={<RenewPage />} />
              <Route
                path="/portal"
                element={
                  <DriverRoute>
                    <DriverPortal />
                  </DriverRoute>
                }
              />

              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/board" element={<LiveBoard />} />
                <Route path="/accounts" element={<ProtectedRoute managerOnly><MonthlyAccounts /></ProtectedRoute>} />
                <Route path="/activity" element={<ProtectedRoute managerOnly><Activity /></ProtectedRoute>} />
                <Route path="/history" element={<ProtectedRoute managerOnly><History /></ProtectedRoute>} />
                <Route path="/reports" element={<ProtectedRoute managerOnly><Reports /></ProtectedRoute>} />
                <Route path="/loyalty" element={<ProtectedRoute managerOnly><Loyalty /></ProtectedRoute>} />
                <Route path="/customers/:id" element={<ProtectedRoute managerOnly><CustomerProfile /></ProtectedRoute>} />
                <Route path="/team" element={<ProtectedRoute managerOnly><Team /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute managerOnly><OwnerDashboard /></ProtectedRoute>} />
                <Route
                  path="/layout-editor"
                  element={
                    <ProtectedRoute ownerOnly>
                      <LayoutEditor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute ownerOnly>
                      <Settings />
                    </ProtectedRoute>
                  }
                />
              </Route>

              <Route path="/" element={<Navigate to="/board" replace />} />
              <Route path="*" element={<Navigate to="/board" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </LocationProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
